import { calculateDiscountPercent } from "@shared/utils/calculate-discount-percent";
import {
  extractData,
  extractDataWithMeta,
} from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import {
  TicketsDtoSchema,
  TicketsPageDtoSchema,
  TicketTypesDtoSchema,
} from "./schemas";
import type { TicketsPageType, TicketsType, TicketTypesType } from "./types";

const defaultMeta = {
  pagination: { page: 1, pageSize: 0, pageCount: 0, total: 0 },
};

export const mapDtoToTicketsPage = (dto: unknown): TicketsPageType => {
  const parsed = safeParseWithFallback(
    TicketsPageDtoSchema,
    dto,
    "mapDtoToTicketsPage",
  );

  return extractData(parsed, dto, dto as TicketsPageType);
};

export const mapDtoToTickets = (dto: unknown): TicketsType => {
  const parsed = safeParseWithFallback(
    TicketsDtoSchema,
    dto,
    "mapDtoToTickets",
  );

  const result = extractDataWithMeta<TicketsType["data"], TicketsType["meta"]>(
    parsed,
    dto,
    defaultMeta as TicketsType["meta"],
  );

  // Рассчитываем процент скидки для каждого билета
  // const ticketsWithDiscount = result.data.map((ticket) => {
  //   // Безопасно получаем данные о ценах с проверкой на null
  //   if (!ticket.price) {
  //     return ticket;
  //   }

  //   const adultPrice = ticket.price.adult;
  //   const childrenPrice = ticket.price.childen;

  //   const adultDiscount =
  //     adultPrice && typeof adultPrice === "object"
  //       ? calculateDiscountPercent(
  //           adultPrice.oldPrice ?? null,
  //           adultPrice.newPrice ?? null,
  //         )
  //       : null;

  //   const childrenDiscount =
  //     childrenPrice && typeof childrenPrice === "object"
  //       ? calculateDiscountPercent(
  //           childrenPrice.oldPrice ?? null,
  //           childrenPrice.newPrice ?? null,
  //         )
  //       : null;

  //   return {
  //     ...ticket,
  //     price: {
  //       ...ticket.price,
  //       adult:
  //         adultPrice && typeof adultPrice === "object"
  //           ? {
  //               ...adultPrice,
  //               discountPercent: adultDiscount,
  //             }
  //           : adultPrice,
  //       childen:
  //         childrenPrice && typeof childrenPrice === "object"
  //           ? {
  //               ...childrenPrice,
  //               discountPercent: childrenDiscount,
  //             }
  //           : childrenPrice,
  //     },
  //   };
  // });

  return {
    ...result,
    data: result.data,
  };
};

export const mapDtoToTicketTypes = (dto: unknown): TicketTypesType[] => {
  const parsed = safeParseWithFallback(
    TicketTypesDtoSchema,
    dto,
    "mapDtoToTicketTypes",
  );

  return extractData(parsed, dto, []);
};
